import { useQuery } from "@tanstack/react-query";
import { userApi } from "@repo/api";
import { userQueryKeys } from "../../../pages/IspmUsers/queryKeys";

export const useGetUserFilters = (enabled: boolean = false) => {
  const { data, isLoading, isError, error, isSuccess } = useQuery({
    queryKey: [userQueryKeys.filters()],
    queryFn: () => userApi.getUserFilters(),
    enabled,
  });

  return { data, isLoading, isError, error, isSuccess };
};
